<!---Echo Header-->
<div *ngIf="(pageType === 'device-listing') || (pageType === 'template-listing') || (pageType === 'batch-listing')">
  <app-metrics [pageType]="pageType"></app-metrics>
</div>
<!--Echo header ends-->

<div [ngClass]="{'mb-3' : pageType === 'view-batch-details'}">
  <div class="mat-elevation-z8" [ngClass]="{'table-responsive' : pageType !== 'view-batch-details'}">

    <div class="echo-device-list-tableheader"
      *ngIf="pageType === 'device-listing' || pageType === 'template-listing' || pageType === 'batch-listing'">
      <span *ngIf="pageType === 'device-listing'" class="table-header">Device List</span>
      <span *ngIf="pageType === 'template-listing'" class="table-header">Template List</span>
      <span *ngIf="pageType === 'batch-listing'" class="table-header">Batch List</span>
      <div class="place-end d-grid grid-column gap10">
        <span class="filer-comp">Filter <img src="../../../../assets/images/filter.svg"></span>
        <span class="form-group has-search mb-0 align-items-center fit-content "
          *ngIf="(pageType === 'template-listing'|| pageType === 'batch-listing' || pageType === 'device-listing')">
          <app-search (searchItem)="search($event)" [pageType]="pageType"></app-search>
        </span>
      </div>
    </div>

    <div [ngClass]="{'-sticky-header': dataSource.data.length > 0}">
      <table mat-table class="mat-elevation-z8 w-100 table-rows" [dataSource]="dataSource" matSort
        [hidden]="!dataSource.data.length">
        <ng-container [matColumnDef]="tableData" *ngFor="let tableData of objectKeys(columnHeader)">
          <ng-container *ngIf="columnHeader[tableData] !== 'Action'">
            <tr>
              <th scope="col" mat-header-cell *matHeaderCellDef>{{columnHeader[tableData]}}</th>
            </tr>
            <tr>
              <td mat-cell *matCellDef="let element" [ngClass]="{'jsonElipses': columnHeader[tableData] === 'Value'}">
                <ng-container *ngIf="errorIconField?.includes(tableData); else commonField">
                  <div class="d-flex align-items-center justify-content-center" *ngIf="pageType === 'device-listing'">
                    <img [matTooltip]="element?.['remarks']" *ngIf="element?.[tableData]"
                      src="../../../../assets/images/error icon.svg" alt="error">
                  </div>
                  <div class="d-flex align-items-center justify-content-center" *ngIf="pageType === 'data-definition'">
                    <img [matTooltip]="'Form Filled'" *ngIf="element?.[tableData] === 'Edited'"
                      src="../../../../assets/images/form-filled.svg" alt="filled">
                    <img [matTooltip]="'Form Unfilled'" *ngIf="element?.[tableData] === 'Not Edited'"
                      src="../../../../assets/images/form-unfilled.svg" alt="unfilled">
                  </div>
                </ng-container>
                <ng-template #commonField>
                  <ng-container *ngIf="fieldList?.includes(tableData); else dateField">
                    <div class="status">
                      <span [ngClass]="(tableData === 'key' && element?.[tableData]?.length > 25) ? 'word-break' : ''"
                        [matTooltip]="element?.[tableData]">{{ (element?.[tableData]) || (element?.[tableData] ===
                        0) ? element?.[tableData] : '--' }}</span>
                      <span
                        *ngIf="tableData === 'name' && element?.['description'] && (pageType === 'data-definition' || pageType === 'template-view')"><img
                          src="../../../../assets/images/info-circle.svg" alt="info" class="h-15"
                          matTooltip="{{ element?.['description'] | titlecase }}" [matTooltipPosition]="'below'"></span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #dateField>
                  <ng-container *ngIf="dateTimeFieldList?.includes(tableData); else statusField">
                    <span [matTooltip]="element?.[tableData] | date : 'dd-MM-yyyy HH:mm:ss'">
                      {{ element?.[tableData]|date: 'dd-MM-yyyy HH:mm:ss' }}</span>
                  </ng-container>
                </ng-template>
                <ng-template #statusField>
                  <ng-container *ngIf="statusFieldList?.includes(tableData); else nonCaseField">
                    <div class="status"><small class="internal-but text-white fs-7 nowrap"
                        [ngStyle]="{ backgroundColor: element?.[tableData]?.backgroundColorCode, width: 'fit-content' }"
                        [style.color]="element?.[tableData]?.colorCode"
                        matTooltip="Status: {{ element?.[tableData]?.title | uppercase }}" [matTooltipPosition]="'left'"
                        title="">{{ element?.[tableData]?.title | titlecase }}</small>
                      <span *ngIf="element?.[tableData]?.type === 'notRunning' && pageType !== 'device-listing'"><img
                          src="../../../../assets/images/info-batch-notrunning.svg" alt="info" class="h-15"
                          matTooltip="{{ element?.['remarks'] | titlecase }}" [matTooltipPosition]="'left'"></span>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #nonCaseField>
                  <ng-container *ngIf="nonCaseFieldList?.includes(tableData); else configurationsField">
                    <span class="d-flex gap10 space-even">
                      <span class="ellipsis"
                        [matTooltip]="tableData==='timeOfSnapshot'?element?.['actualTimeOfSnapshot']:element?.[tableData]">
                        {{element?.[tableData] ? element?.[tableData] : '--' }} </span>
                      <span [matTooltip]="getTagStatus(element?.['tagUntagStatus']).tooltip"
                        *ngIf="pageType === 'device-listing' && tableData === 'batchId'">
                        <img [src]="getTagStatus(element?.['tagUntagStatus']).src" alt="Tag Status">
                      </span>
                    </span>
                  </ng-container>
                </ng-template>
                <ng-template #configurationsField>
                  <ng-container *ngIf="configurationsList?.includes(tableData); else otherField">
                    <div class="configurations-chip-wrapper-common-table">
                      <small class="internal-but text-white fs-7 nowrap"
                        *ngFor="let configField of element?.[tableData]" matTooltipPosition="above"
                        [matTooltip]="configField?.value.length > 25 ? configField?.value : ''"
                        [ngStyle]="{ backgroundColor: configField?.backgroundColorCode, width: 'fit-content' }"
                        [style.color]="configField?.colorCode" title="">{{ configField?.key + ': ' + (configField?.value
                        | truncate )
                        }}</small>
                    </div>
                  </ng-container>
                </ng-template>
                <ng-template #otherField>
                  <ng-container>
                    <span [matTooltip]="element?.[tableData]"> {{ element?.[tableData] ? element?.[tableData] : '--'
                      }}</span>
                  </ng-container>
                </ng-template>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="columnHeader[tableData] === 'Action'">
            <tr>
              <th scope="col" mat-header-cell *matHeaderCellDef>{{columnHeader[tableData]}}</th>
            </tr>
            <tr>
              <td mat-cell *matCellDef="let element; let i = index" class="action-icons">
                <div class="form-gap d-flex">
                  <span *ngIf="actionPermission.batchActivity && element?.['runningStatusRenderer']?.type==='running'"
                    [ngClass]="{'disabled': element?.['actionStatus'] === 'queued'}">
                    <a (click)="onActionClick(element,'batchActivity')">
                      <img src="../../../../assets/images/pause.svg" alt="share" matTooltip="Stop Batch"
                        class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>
                  <span
                    *ngIf="actionPermission.batchActivity && element?.['runningStatusRenderer']?.type==='notRunning'"
                    [ngClass]="{'disabled':  !timeWithinSchedule[i] || element?.['actionStatus'] === 'queued'}">
                    <a (click)="onActionClick(element,'batchActivity')">
                      <img src="../../../../assets/images/play.svg" alt="share" matTooltip="Start Batch"
                        class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.enableBatch">
                    <a (click)="onActionClick(element,'enableBatch')" matTooltip="Active/Inactive Batch">
                      <img src="../../../../assets/images/toggle.svg" alt="active" class="h-30 toggle cursor img-fluid"
                        *ngIf="element?.['scheduledStatusRenderer']?.type==='active'">
                      <img src="../../../../assets/images/toggle-disable.svg" alt="inactive"
                        class="h-30 toggle cursor img-fluid"
                        *ngIf="element?.['scheduledStatusRenderer']?.type==='inactive'">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.view">
                    <a (click)="onActionClick(element,'view')" title="View">
                      <img src="../../../../assets/images/eye-blue.svg" title="View" alt="View"
                        class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.restore">
                    <a (click)="onActionClick(element,'restore')" title="Restore">
                      <img src="../../../../assets/images/restore.svg" title="Restore" alt="Restore Icon"
                        class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.edit">
                    <a (click)="onActionClick(element,'edit')" title="Edit">
                      <img src="../../../../assets/images/edit-blue.svg" title="Edit" alt="Edit Icon"
                        class="h-30 cursor icon-bg img-fluid-edit">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.clone">
                    <a (click)="onActionClick(element,'clone')" title="Clone">
                      <img src="../../../../assets/images/clone.svg" title="Clone" alt="Clone"
                        class="h-30 icon-bg cursor">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.attach">
                    <a (click)="onActionClick(element,'attach')" title="Attach">
                      <img src="../../../../assets/images/paper-clip.svg" title="Attach" alt="Attach"
                        class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.detach" [ngClass]="{'disabled': element?.['runningStatusRenderer']?.type==='running'}">
                    <a (click)="onActionClick(element,'detach')" title="Detach">
                      <img src="../../../../assets/images/paper-clip.svg" title="Detach" alt="Detach"
                        class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>
                  <span *ngIf="actionPermission.viewPayload">
                    <a (click)="onActionClick(element,'viewPayload')" title="View Payload">
                      <img src="../../../../assets/images/view_device_payload.svg" title="View Payload"
                        alt="View Payload" class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>

                  <span *ngIf="actionPermission.delete">
                    <a (click)="onActionClick(element,'delete')" title="Delete">
                      <img src="../../../../assets/images/delete.svg" title="Delete" alt="Delete"
                        class="h-30 cursor icon-bg">
                    </a>
                  </span>

                  <span *ngIf="actionPermission.download" class="download_Icon cursor"
                    [ngClass]="{'disabled': (pageType === 'dataArchival' && !element?.url)}">
                    <a [href]="element.url" title="Download">
                      <img src="../../../../assets/images/downloadSimple-r.svg" title="Download" alt="Download"
                        class="h-30 cursor icon-bg">
                    </a>
                  </span>

                  <span *ngIf="actionPermission.viewMore">
                    <a (click)="onActionClick(element, 'viewMore')" title="Live Data">
                      <img src="../../../../assets/images/eye-developer.svg" title="View" alt="View More"
                        class="h-30 cursor icon-bg">
                    </a>
                  </span>

                  <span *ngIf="actionPermission.simulationSettings">
                    <a (click)="onActionClick(element,'simulationSettings')" title="Simuation Settings">
                      <img src="../../../../assets/images/simulation_settings.svg" title="Simuation Settings"
                        alt="Simuation Settings" class="h-30 cursor icon-bg img-fluid">
                    </a>
                  </span>

                  <span *ngIf="actionPermission.toggle && elipsesActionPermission" [matMenuTriggerFor]="exportPop"
                    #popTrigger="matMenuTrigger" (click)="popTrigger.openMenu()">
                    <a title="Toggle">
                      <img src="../../../../assets/images/elipses.svg" title="View" alt="View More"
                        class="h-30 cursor icon-bg">
                    </a>
                  </span>
                  <!-- menu -->
                  <ng-container>
                    <mat-menu #exportPop="matMenu" [hasBackdrop]="true" xPosition="before">
                      <div class="elipses-space-around" *ngIf="elipsesActionPermission">

                        <span *ngIf="elipsesActionPermission.view">
                          <a (click)="onActionClick(element,'view')" title="View">
                            <img src="../../../../assets/images/eye-blue.svg" title="View" alt="View"
                              class="h-30 cursor icon-bg img-fluid">
                          </a>
                        </span>

                        <span *ngIf="elipsesActionPermission.edit">
                          <a (click)="onActionClick(element,'edit')" title="Edit">
                            <img src="../../../../assets/images/edit-blue.svg" title="Edit" alt="Edit Icon"
                              class="h-30 cursor icon-bg img-fluid-edit">
                          </a>
                        </span>
                        <span *ngIf="elipsesActionPermission.clone">
                          <a (click)="onActionClick(element,'clone')" title="Clone">
                            <img src="../../../../assets/images/clone.svg" title="Clone" alt="Clone"
                              class="h-30 icon-bg cursor">
                          </a>
                        </span>
                        <span *ngIf="elipsesActionPermission.attach">
                          <a (click)="onActionClick(element,'attach')" title="Attach" [ngClass]="{'disabled': element?.['runningStatusRenderer']?.type==='running'}">
                            <img src="../../../../assets/images/paper-clip.svg" title="Attach" alt="Attach"
                              class="h-30 cursor icon-bg img-fluid">
                          </a>
                        </span>
                        <span *ngIf="elipsesActionPermission.detach" [ngClass]="{'disabled': element?.['runningStatusRenderer']?.type==='running'}">
                          <a (click)="onActionClick(element,'detach')" title="Detach">
                            <img src="../../../../assets/images/detach.svg" title="Detach" alt="Detach"
                              class="h-30 cursor icon-bg img-fluid">
                          </a>
                        </span>
                        <span *ngIf="elipsesActionPermission.delete">
                          <a (click)="onActionClick(element,'delete')" title="Delete">
                            <img src="../../../../assets/images/delete.svg" title="Delete" alt="Delete"
                              class="h-30 cursor icon-bg">
                          </a>
                        </span>
                      </div>
                    </mat-menu>
                  </ng-container>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader); sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: objectKeys(columnHeader);"></tr>
      </table>
    </div>
    <div [hidden]="dataSource.data.length>0 || loadStatus" class="no-records">
      <div class="d-flex justify-content-center align-items-center vh-75">
        <div class="text-center image-style">
          <img src="../../../assets/images/nodata.svg" class="w-10" alt="no-data">
        </div>
      </div>
    </div>
  </div>
</div>
<mat-paginator *ngIf="actionPermission?.showPaginator" #paginator
  [hidden]="dataSource.data.length<pageSize || pageType === 'snapshot' || pageType === 'template-summary' || pageType === 'batch-management' "
  [length]="dataSource.data.length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
  [showFirstLastButtons]="true" (page)="pagination($event)" disableOptionCentering="true">
</mat-paginator>